
// import { Injectable } from '@angular/core';
// import {
//   HttpEvent,
//   HttpHandler,
//   HttpInterceptor,
//   HttpRequest,
//   HttpErrorResponse
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { catchError } from 'rxjs/operators';
// import { Router } from '@angular/router';
// import { AuthService } from '../auth/auth.service';
// import { ToastrService } from 'ngx-toastr';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {

//   constructor(
//     private authService: AuthService,
//     private router: Router,
//     private toastr: ToastrService
//   ) {}

//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {

//     const token = this.authService.getToken();

//     if (token) {
//       request = request.clone({
//         setHeaders: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//     }

//     return next.handle(request).pipe(
//       catchError((error: HttpErrorResponse) => {

//         if (error.status === 401 || error.error?.code === 401) {

//           this.toastr.error(
//             error.error?.message || 'Unauthorized access. Please login again.'
//           );

//           localStorage.clear();
//           sessionStorage.clear();

//           this.router.navigate(['/login']);
//         }

//         return throwError(() => error);
//       })
//     );
//   }
// }


import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const token = this.authService.getToken();

    if (token) {

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(

      catchError((error: HttpErrorResponse) => {

        if (
          error.status === 401 ||
          error.error?.code === 401
        ) {

          this.authService.clearSession();

          if (this.router.url !== '/login') {

            this.toastr.error(
              error.error?.message ||
              'Session expired. Please login again.'
            );

            this.router.navigate(['/login']);
          }
        }

        return throwError(() => error);
      })
    );
  }
}